require('../../modules/es.object.keys');
var path = require('../../internals/path');

module.exports = path.Object.keys;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/object/keys.js
// module id = 444
// module chunks = 0